//constants for server use

export const serverURL = "https://athledaarise.org/backend/"
export const websiteURL = "https://athledaarise.org/"
export const mainURL = "https://athledaarise.org/#/main"
export const cognitoURL = "https://athledafoundation.auth.us-east-2.amazoncognito.com/oauth2/authorize?client_id=73chk8i1mt8m6kai7018dease1&response_type=code&scope=email+openid+phone&redirect_uri=https%3A%2F%2Fathledaarise.org%2F"
export const signOutURL = "https://athledafoundation.auth.us-east-2.amazoncognito.com/logout?client_id=73chk8i1mt8m6kai7018dease1&logout_uri=https%3A%2F%2Fathledaarise.org%2F"




//constants for local use

// export const serverURL = "http://localhost:8080/backend/"
// export const websiteURL = "http://localhost:3000/"
// export const mainURL = "http://localhost:3000/#/main"
// export const cognitoURL = "https://athledafoundation.auth.us-east-2.amazoncognito.com/oauth2/authorize?client_id=6laggootisjgk3iiun22v7itqq&response_type=code&scope=email+openid+phone&redirect_uri=http%3A%2F%2Flocalhost%3A3000%2F"
// export const signOutURL = "https://athledafoundation.auth.us-east-2.amazoncognito.com/logout?client_id=6laggootisjgk3iiun22v7itqq&logout_uri=http%3A%2F%2Flocalhost%3A3000%2F"



//AWS constants
export const mentorImageBucketURL = "https://findmentor.s3.us-east-2.amazonaws.com/"
